module.exports = __webpack_public_path__ + "media/src/images/balloons/banner_glasses-bcab57f83d5ac53f2b0dd6759fa51234.gif";